import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Trophy, Crown, BadgeCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import Avatar from "@/components/Avatar";

const MEDAL = ["#FFD700", "#C0C0C0", "#CD7F32"];

export default function Leaderboard() {
  const nav = useNavigate();
  const [board, setBoard] = useState([]);
  const [myRank, setMyRank] = useState(null);
  const [myId, setMyId] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/leaderboard");
        setBoard(data.board);
        setMyRank(data.my_rank);
        setMyId(data.my_id);
      } catch (e) { toast.error(errMsg(e)); }
    })();
  }, []);

  return (
    <div className="px-5 pt-6" data-testid="leaderboard-page">
      <div className="flex items-center gap-2">
        <Trophy className="text-[#FFD700]" size={24} />
        <span className="label-xs text-slate-500">Clout Rankings</span>
      </div>
      <h1 className="font-display text-3xl mt-1">Who Be <span className="text-[#FFD700]">Baller?</span></h1>

      {myRank && (
        <div className="mt-4 bg-[#FF0055]/10 border border-[#FF0055]/30 rounded-xl p-3 flex items-center justify-between">
          <span className="text-sm text-slate-600">Your position</span>
          <span className="font-display text-xl text-[#FF0055]">#{myRank}</span>
        </div>
      )}

      <div className="mt-5 space-y-2 mb-4">
        {board.map((b, i) => {
          const mine = b.id === myId;
          return (
            <motion.button
              key={b.id}
              initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.02 }}
              data-testid={`rank-${i + 1}`}
              onClick={() => nav(mine ? "/me" : `/player/${b.id}`)}
              className={`w-full flex items-center gap-3 rounded-xl p-3 text-left transition-colors ${
                mine ? "bg-[#16A34A]/10 border border-[#16A34A]/40" : "bg-white border border-slate-200 hover:border-white/25"
              }`}
            >
              <div className="w-8 text-center font-display text-lg" style={{ color: MEDAL[i] || "#52525b" }}>
                {i < 3 ? <Crown size={18} className="mx-auto" /> : i + 1}
              </div>
              <div className="text-2xl"><Avatar src={b.avatar} size={36} idle /></div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-slate-900 truncate flex items-center gap-1">
                  {b.name} {b.verified && <BadgeCheck size={14} className="text-[#00E5FF]" />}
                </div>
                <div className="label-xs text-slate-500">{b.city} · Lv{b.level}</div>
              </div>
              <div className="text-right">
                <div className="font-display text-[#FF0055] neon-text">{b.clout}</div>
                <div className="label-xs text-slate-400">clout</div>
              </div>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}
